<template>
  <v-footer class="font-weight-medium footer" dark app>
    <my-container>
      <v-row class="mx-0">
        <v-col cols="12" lg="3">
          <div class="footer__logo-wrapper">
            <picture class="footer__logo-img mb-2 mr-2">
              <img src="@/assets/img/_src/FMSH.svg" width="52" alt="Лого" />
            </picture>
            <span class="text-caption">Физико-математическая школа</span>
          </div>
          <a
            href="https://vk.com/fmsh.bmstu"
            target="_blank"
            class="footer__vk mt-2"
            ><i class="vk-icon fab fa-vk"></i
          ></a>
        </v-col>
        <v-col cols="12" lg="4" offset-lg="1">
          <ul class="footer__info">
            <li class="footer__info-item">
              <i class="footer__info-icon fas fa-location-arrow"></i>
              <span class="footer__info-link text-subtitle-2"
                >г. Москва, ул. 2-я Бауманская, д. 5, к. 5</span
              >
            </li>
            <li class="footer__info-item">
              <i class="footer__info-icon fas fa-envelope"></i>
              <a
                class="footer__info-link text-subtitle-2"
                href="mailto:fmsh@bmstu.ru"
                >fmsh@bmstu.ru</a
              >
            </li>
            <li
              class="footer__info-item"
              v-for="(phone, key) in phones"
              :key="key"
            >
              <i class="footer__info-icon fas fa-phone-alt"></i>
              <a
                class="footer__info-link text-subtitle-2"
                :href="`tel:${phone.phone}`"
                >{{ phone.viewPhone }}</a
              >
            </li>
          </ul>
        </v-col>
        <v-col cols="12" lg="4">
          <iframe
            class="footer__map"
            src="https://yandex.ru/map-widget/v1/-/CCUI4QSQoB"
            frameborder="0"
            allowfullscreen="true"
          ></iframe>
        </v-col>
      </v-row>
    </my-container>
  </v-footer>
</template>

<script>
import MyContainer from "@/components/MyContainer";
import API from "@/common/api/api.functions";
export default {
  name: "Footer",
  components: { MyContainer },
  data() {
    return {
      year_created: 2020,
      contacts: [],
      rePhone: /[^\d+]/
    };
  },
  created() {
    this.loadYearCreated();
    this.getContactsData();
  },
  computed: {
    phones() {
      if (!this.contacts || !this.contacts.length) {
        return [];
      }
      const rePhone = /[^\d+]/;
      let withPhones = this.contacts.filter(val => !!val.phone);
      if (!withPhones.length) {
        return [];
      }
      return withPhones.map(val => ({
        phone: val.phone.replace(rePhone, ""),
        viewPhone: val.phone
      }));
    }
  },
  methods: {
    async getContactsData() {
      this.contacts = await API.getFooterContacts().then(
        response => response.data
      );
    },
    async loadYearCreated() {
      let now_year = new Date().getFullYear();
      this.year_created < now_year
        ? (this.year_created = this.year_created + " - " + now_year)
        : (this.year_created = now_year.toString());
    }
  }
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}

.v-footer {
  position: relative !important;
}

.footer {
  background-color: #242424 !important;
  padding: 72px 0 83px 0 !important;
}

.footer__logo-wrapper {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

@media (max-width: 959px) {
  .footer__logo-wrapper {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

.footer__logo-text {
  margin-top: 7px;
  color: #fff;
  font-size: 14px;
  line-height: 15px;
}

@media (max-width: 959px) {
  .footer__logo-text {
    margin-left: 10px;
    width: 30%;
    margin-top: 0;
  }
}

@media (max-width: 599px) {
  .footer__logo-text {
    width: 50%;
  }
}

.footer__vk {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: 16px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: rgba(196, 196, 196, 0.3);
}

.footer__vk .vk-icon {
  font-size: 16px;
  line-height: 18px;
  color: #d7d7d7;
}

@media (max-width: 959px) {
  .footer__menu {
    margin-top: 30px;
  }
}

.footer__info {
  display: flex;
  flex-direction: column;
  @media (max-width: 959px) {
    .footer__info {
      margin-top: 30px;
    }
  }
}

.footer__menu-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 15px;
}

.footer__menu-item:last-child {
  margin-bottom: 0;
}

.footer__menu-icon {
  display: inline-block;
  -webkit-transform: translateY(-1px);
  -ms-transform: translateY(-1px);
  transform: translateY(-1px);
  margin-right: 10px;
}

.footer__menu-link {
  font-size: 16px;
  line-height: 21px;
  text-decoration: none;
  color: #cecece;
}

.footer__menu-link:hover {
  color: #fff;
  text-decoration: none;
}

.footer__info-link {
  font-size: 16px;
  line-height: 21px;
  color: #fafafa !important;
}

.footer__info-link--black {
  color: #333;
}

.footer__info-link--black:hover {
  color: #00f;
}

.footer__info-link:hover {
  color: #fff;
  text-decoration: none;
}

.footer__info-icon {
  margin-right: 15px;
  -webkit-transform: translateY(3px);
  -ms-transform: translateY(3px);
  transform: translateY(3px);
  font-size: 14px;
  color: #797979;
}

.footer__info-icon--blue {
  color: #4350b9;
}

.footer__info-item {
  display: inline-flex;
  margin-top: 15px;
  align-items: flex-start;
}

.footer__info-item:first-child {
  margin-top: 0;
}

.footer__map {
  width: 100%;
  height: 180px;
}

@media (max-width: 959px) {
  .footer__map {
    margin-top: 30px;
  }
}

.footer__logo-img {
  display: inline-block;
}
</style>
